import React, { useEffect, useState } from "react";
import { Button, Card, PageTitle } from "src/components";
import styles from "./Logs.module.scss";
import Axios from "src/services/api";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const Logs = () => {
  const [logs, setLogs] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    Axios.get("/delivered-webhooks")
      .then((res) => {
        setLogs(res.data.deliveredWebhooks);
      })
      .catch((err) => {
        console.error("Error fetching webhook logs:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleRowClick = (logId: string) => {
    navigate(`/developers/logs/${logId}`);
  };

  return (
    <div className={styles.settingsPage}>
      <PageTitle
        actions={
          <div style={{ display: "flex", gap: 10 }}>
            <Button
              text="Docs"
              variant="tertiary"
              onClick={() =>
                window.open(
                  "https://helpcenter.pocketsflow.com/en/articles/10516809-webhooks",
                  "_blank"
                )
              }
            />
          </div>
        }
      >
        Webhook Logs
      </PageTitle>
      <Card>
        <h3 className={styles.cardTitle}>Webhook Delivery Logs</h3>
        {loading ? (
          <div className={styles.emptyState}>
            <p>Loading...</p>
          </div>
        ) : logs.length === 0 ? (
          <div className={styles.emptyState}>
            <p>No webhook logs found</p>
          </div>
        ) : (
          <div className={styles.itemsList}>
            <div className={styles.tableWrapper}>
              <table>
                <thead>
                  <tr>
                    <th>Event</th>
                    <th>Webhook ID</th>
                    <th>Sent Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {logs?.map((log: any) => (
                    <tr 
                      key={log._id} 
                      onClick={() => handleRowClick(log._id)}
                      className={styles.clickableRow}
                    >
                      <td>{log.event}</td>
                      <td>
                        <span style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          width: "100%",
                          display: "inline-block"
                        }}>
                          {log.webhookId}
                        </span>
                      </td>
                      <td>{dayjs(log.sentDate).fromNow()}</td>
                      <td>
                        <div
                          className={`${styles.status} ${log.isSuccessful ? styles.active : styles.failed
                            }`}
                        >
                          {log.isSuccessful ? "Success" : "Failed"}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
};

export default Logs; 